<script lang="ts" setup>
import { Toaster as Sonner, type ToasterProps } from 'vue-sonner'

const props = defineProps<ToasterProps>()
</script>

<template>
  <Sonner
    class="tw:toaster tw:group"
    v-bind="props"
    :style="{
      '--normal-bg': 'var(--popover)',
      '--normal-text': 'var(--popover-foreground)',
      '--normal-border': 'var(--border)',

    }"
  />
</template>

<style>
@import '../../../../../css/tailwind.css';

[data-sonner-toaster] li[data-type="success"] svg {
  @apply tw:text-green-600;
}
[data-sonner-toaster] li[data-type="error"] svg {
  @apply tw:text-red-600;
}
</style>
